import { useState, useCallback } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import "./App.css";
import Navbar from "./components/navbar/Navbar";
import Home from "./components/Pages/Home";
import Footer from "./components/footer/Footer";
import Contact from "./components/Contact/Contact";
import FAQ from "./components/Contact/Faqs";
import WhatsAppButton from "./components/WhatsAppButton";
import ProductListWithCategories from "./components/Catalogue/Page";
import ProductListWithFilters from "./components/Catalogue/ListPro";
import ProductDetail from "./components/Catalogue/ProductDetails";
import Abouttest from "./components/about/AboutTest";
import Splash from "./components/splash/Splash";
import { splashPending, markSplashSeen } from "./splash";

function AnimatedRoutes() {
  const location = useLocation(); // Détecte la route actuelle

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route
          path="/"
          element={
            <PageTransition>
              <Home />
            </PageTransition>
          }
        />
        <Route
          path="/about"
          element={
            <PageTransition>
              <Abouttest />
            </PageTransition>
          }
        />
        <Route
          path="/contact"
          element={
            <PageTransition>
              <Contact />
            </PageTransition>
          }
        />
        <Route
          path="/FAQ"
          element={
            <PageTransition>
              <FAQ />
            </PageTransition>
          }
        />
        <Route
          path="/catalogue"
          element={
            <PageTransition>
              <ProductListWithCategories />
            </PageTransition>
          }
        />
          <Route
          path="/catalogue/:idcode"
          element={
            <PageTransition>
              <ProductListWithFilters />
            </PageTransition>
          }
        />    <Route
        path="/product/:id"
        element={
          <PageTransition>
            <ProductDetail />
          </PageTransition>
        }
      />
      </Routes>
      
    </AnimatePresence>
  );
}

// Steel panel wipes up over the old page, then lifts away to reveal the new one.
function PageTransition({ children }) {
  const reduceMotion = useReducedMotion();

  if (reduceMotion) return <>{children}</>;

  return (
    <>
      <motion.div
        className="page-wipe"
        initial={{ y: "0%" }}
        animate={{ y: "-100%" }}
        exit={{ y: ["100%", "0%"] }}
        transition={{ duration: 0.5, ease: [0.76, 0, 0.24, 1] }}
      />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.25, ease: "easeOut" }}
      >
        {children}
      </motion.div>
    </>
  );
}

export default function App() {
  const [showSplash, setShowSplash] = useState(() => {
    // The intro only plays when the visit starts on the home page.
    if (window.location.pathname !== "/") {
      markSplashSeen();
      return false;
    }
    return splashPending();
  });

  const handleSplashDone = useCallback(() => {
    markSplashSeen();
    setShowSplash(false);
  }, []);

  return (
    <Router>
      <AnimatePresence>
        {showSplash && <Splash onDone={handleSplashDone} />}
      </AnimatePresence>
      <Navbar />
      <AnimatedRoutes />
      <Footer />
      <WhatsAppButton />
    </Router>
  );
}
